(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .provider('chartConfig', chartConfig);

    // configuration
    chartConfig.$inject = ['chartConstants'];
    function chartConfig(chartConstants) {
        this.yieldCurveChartDefaultObject = {
            // title: {
            //     //Title text is to be filled in the app
            //     text: '',
            //     //Configure chart title font
            //     font:{
            //         opacity: 1,
            //         fontFamily: "Open Sans",
            //         fontWeight: 'lighter',
            //         color: "#337AB6",
            //         size: '16px'
            //     }
            // },
            //Configure Primary X Axis
            primaryXAxis: {
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#000000de"
                },
                visible: true, // to be changed for empty charts
                title: {visible: false, text: 'Tenor'},
                axisLine: {visible: true},
                majorGridLines: {visible: true, },
                majorTickLines: {visible: true},
                rangePadding: 'none',
                valueType: 'double',
                labelPlacement: 'onticks',
                labelIntersectAction: 'multipleRows',
                isIndexed: false,
                range: {min: 0, interval: 365}
            },
            //Configure Primary Y Axis
            primaryYAxis: {
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#000000de"
                },
                title: {
                    visible: true,
                    text: 'Yield (%, annually compounded)',
                    font: {
                        size: "13px",
                        fontFamily: "Helvetica",
                        color: "#000000de"
                    }
                },
                visible: true, // to be changed for empty charts
                axisLine: {visible: true},
                opacity: 0,
                majorGridLines: {visible: true}//, rangePadding: 'additional'
            },
            //Configure Common Properties for all the series
            commonSeriesOptions: {
                enableAnimation: true,
                opacity: 0.75,
                border: {
                    width: 2
                },
                marker: {
                    border: {
                        width: 0
                    }
                },
                highlightSettings: {
                    enable: true,
                    mode: 'series',
                    opacity: 1
                }
            },
            //Series are to be filled in the app
            series: [],
            //Configure Zooming
            zooming: {
                enable: false,
                enableMouseWheel: false,
                enableScrollbar: true,
                type: 'x,y'
            },
            //Configure Trackball
            crosshair: {
                visible: true,
                type: 'trackball'
            },
            //OnLoad event handler
            // load: onChartLoaded,
            //Chart appearance and other properties
            chartArea: {
                border: {
                    opacity: 1
                }
            },
            border: {
                width: 0,
                color: "#5250A1"
            },
            canResize: true,
            isResponsive: true,
            legend: {
                visible: true,
                shape: 'seriesType',
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#000000de"
                }
            },
            size: {
                height: '250'//,width: '300'
            },
            annotations: [{
                visible: false, // to be changed for empty charts
                content: "watermark",
                opacity: 0.2,
                region: "series"
            }],
            //customize the trackball tooltip
            // tooltip: {visible: true, format: " #point.text# : #point.y#  "},
            trackToolTip: onTooltipShown,
            axesLabelRendering: onAxisLabelRender
        };

        this.yieldCurveChartDefaultLineStyles = {
            predefined: [ //todo: only six lines are predefined so far, will see if more is needed
                {
                    width: 3,
                    color: chartConstants.lineColorSet[0],
                    dashSetting: [1, 0],
                    markerShape: 'Circle',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[1],
                    dashSetting: [1, 0],
                    markerShape: 'Diamond',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[2],
                    dashSetting: [1, 0],
                    markerShape: 'InvertedTriangle',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[3],
                    dashSetting: [1, 0],
                    markerShape: 'Star',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[4],
                    dashSetting: [1, 0],
                    markerShape: 'Triangle',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[5],
                    dashSetting: [1, 0],
                    markerShape: 'Pentagon',
                    markerSize: 2
                }
            ],
            new: {
                width: 3,
                color: null, //will be picked automatically
                dashSetting: [1, 0],
                markerShape: 'None',
                markerSize: 0
            }
        };

        this.xTicksTranslations = {
            "today": { en: "today", ru: "сегодня", ro: "azi" },
            "1 day": { en: "1 day", ru: "1 день", ro: "1 zi" },
            "1 week": { en: "1 week", ru: "1 неделя", ro: "1 săptămână" },
            "2 weeks": { en: "2 weeks", ru: "2 недели", ro: "2 săptămâni" },
            "3 weeks": { en: "3 weeks", ru: "3 недели", ro: "3 săptămâni" },
            "1 month": { en: "1 month", ru: "1 месяц", ro: "1 lună" },
            "2 months": { en: "2 months", ru: "2 месяца", ro: "2 luni" },
            "1 quarter": { en: "1 quarter", ru: "1 квартал", ro: "1 trimestru" },
            "2 quarters": { en: "2 quarters", ru: "2 квартала", ro: "2 trimestre" },
            "3 quarters": { en: "3 quarters", ru: "3 квартала", ro: "3 trimestre" },
            "1 year": { en: "1 year", ru: "1 год", ro: "1 an" },
            "5 quarters": { en: "5 quarters", ru: "5 кварталов", ro: "5 trimestre" },
            "6 quarters": { en: "6 quarters", ru: "6 кварталов", ro: "6 trimestre" },
            "7 quarters": { en: "7 quarters", ru: "7 кварталов", ro: "7 trimestre" },
            "2 years": { en: "2 years", ru: "2 года", ro: "2 ani" },
            "3 years": { en: "3 years", ru: "3 года", ro: "3 ani" },
            "4 years": { en: "4 years", ru: "4 года", ro: "4 ani" },
            "5 years": { en: "5 years", ru: "5 лет", ro: "5 ani" },
            "6 years": { en: "6 years", ru: "6 лет", ro: "6 ani" },
            "7 years": { en: "7 years", ru: "7 лет", ro: "7 ani" },
            "8 years": { en: "8 years", ru: "8 лет", ro: "8 ani" },
            "9 years": { en: "9 years", ru: "9 лет", ro: "9 ani" },
            "10 years": { en: "10 years", ru: "10 лет", ro: "10 ani" },
            "11 years": { en: "11 years", ru: "11 лет", ro: "11 ani" },
            "12 years": { en: "12 years", ru: "12 лет", ro: "12 ani" },
            "13 years": { en: "13 years", ru: "13 лет", ro: "13 ani" },
            "14 years": { en: "14 years", ru: "14 лет", ro: "14 ani" },
            "15 years": { en: "15 years", ru: "15 лет", ro: "15 ani" },
            "16 years": { en: "16 years", ru: "16 лет", ro: "16 ani" },
            "17 years": { en: "17 years", ru: "17 лет", ro: "17 ani" },
            "18 years": { en: "18 years", ru: "18 лет", ro: "18 ani" },
            "19 years": { en: "19 years", ru: "19 лет", ro: "19 ani" },
            "20 years": { en: "20 years", ru: "20 лет", ro: "20 ani" },
            "21 years": { en: "21 years", ru: "21 год", ro: "21 de ani" },
            "22 years": { en: "22 years", ru: "22 года", ro: "22 de ani" },
            "23 years": { en: "23 years", ru: "23 года", ro: "23 de ani" },
            "24 years": { en: "24 years", ru: "24 года", ro: "24 de ani" },
            "25 years": { en: "25 years", ru: "25 лет", ro: "25 de ani" },
            "26 years": { en: "26 years", ru: "26 лет", ro: "26 de ani" },
            "27 years": { en: "27 years", ru: "27 лет", ro: "27 de ani" },
            "28 years": { en: "28 years", ru: "28 лет", ro: "28 de ani" },
            "29 years": { en: "29 years", ru: "29 лет", ro: "29 de ani" },
            "30 years": { en: "30 years", ru: "30 лет", ro: "30 de ani" }
        };

        this.$get = function () {
            return {
                yieldCurveChartDefaults: {
                    chartObject: this.yieldCurveChartDefaultObject,
                    lineStyles: this.yieldCurveChartDefaultLineStyles,
                    xTicksTranslations: this.xTicksTranslations
                }
            };
        };

        function onTooltipShown(sender) {
            var dataPoint = sender.data.Series.dataPoint[sender.data.pointIndex];
            //reformat Y number up to 4th precision point
            sender.data.currentText = dataPoint.text + " : " + dataPoint.y.toPrecision(4);
        }

        function onAxisLabelRender(sender) {
            // format horizontal axis
            if (sender.data.axis.orientation === 'horizontal') {
                var actInterval = angular.copy(sender.data.axis.actualRange.interval);
                actInterval = (actInterval >= 365) ? 365 : 1;
                var freqLetter = (actInterval === 365) ? "Y" : "D";
                sender.data.label.Text = (sender.data.label.Text == "0")
                    ? "" // show "" for the zero tenor
                    : parseFloat(sender.data.label.Text) / actInterval + freqLetter;
            }
        }
    }
})();
